import axios from 'axios'

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL_PROD ||
  process.env.REACT_APP_API_URL ||
  'http://localhost:3000'

export const PLATFORM_TOKEN_KEY = 'platform_token'

const platformApi = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

platformApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(PLATFORM_TOKEN_KEY)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

export function platformErrorMessage(error, fallback) {
  return error?.response?.data?.message || fallback
}

export default platformApi
